import { EventModel } from '@bryntum/scheduler';

export default class DispatchEventModel extends EventModel {
    static get $name() {
        return 'DispatchEventModel';
    }

    static get fields() {
        return [
            'brokerId',
            'broker',
            'clientId',
            'driverId',
            'driver',
            'endDate',
            'equipmentId',
            'equipment',
            'id',
            'name',
            'orderLineItemId',
            'startDate',
            'onsiteTime',
            'yardTime',
            'released',
            'addressLine1',
            'addressLine2',
            'country',
            'city',
            'state',
            'zipCode',
            'isScheduled',
            'isOrderInReview',
            'lineItemNumber',
            'jobNumber',
            'orderNumber',
            'description',
            'equipmentNeeded',
            'arrivalTime',
            'quoteMemo',
            'orderMemo',
            'driverMemo',
            'internalMemo',
            'lineItemMemo',
            'dispatchMemo',
            'driverComment',
        ];
    }

    static get defaults() {
        return {
            durationUnit: 'h',

            name: 'New event',
        };
    }

    getDurationMS = () => {
        return this.durationMS;
    };
}
